import slugify from "slugify";

export const getSlug = (title: string, locale: string) => {
  return slugify(title, {
    locale,
  }).toLowerCase();
};
